import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsedAiCreditsState } from '../reducers/used-ai-credits.reducer';
import {DbStoreState} from "../reducers";

export const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');
export const selectUsedAiCreditsState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.usedAiCredits);

export const selectUsedAiCredits = createSelector(
  selectUsedAiCreditsState,
  (state: UsedAiCreditsState) => state.credits
);

export const selectUsedAiCreditsLoading = createSelector(
  selectUsedAiCreditsState,
  (state: UsedAiCreditsState) => state.loading
);

export const selectUsedAiCreditsError = createSelector(
  selectUsedAiCreditsState,
  (state: UsedAiCreditsState) => state.error
);
